(function () {
  function formatDate(d) {
    return d.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short"
    });
  }

  function addBusinessDays(startDate, days) {
    const d = new Date(startDate);
    let added = 0;

    while (added < days) {
      d.setDate(d.getDate() + 1);
      const day = d.getDay();
      if (day !== 0 && day !== 6) {
        added++;
      }
    }
    return d;
  }

  function updateDeliveryWindows() {
    const nodes = document.querySelectorAll("[data-delivery-window]");
    if (!nodes.length) return;

    const now = new Date();

    nodes.forEach((el) => {
      const minDays = parseInt(el.getAttribute("data-min"), 10);
      const maxDays = parseInt(el.getAttribute("data-max"), 10);

      const minDate = addBusinessDays(now, minDays);
      const maxDate = addBusinessDays(now, maxDays);

      el.textContent = `${formatDate(minDate)} – ${formatDate(maxDate)}`;
    });
  }

  document.addEventListener("DOMContentLoaded", updateDeliveryWindows);
})();
